import { useAccount } from './requests/use-account';

export function useIsPayInAdvanceOnTierCrossVisible(): boolean {
  const { data: accountData } = useAccount();

  return accountData?.account.settings.productSettings?.tieredSubscription?.payInAdvanceOnTierCross ?? false;
}
